import type { ButtonProps } from '@mui/material'
import { Button } from '@mui/material'
import React from 'react'
import type { LinkProps as RouterLinkProps } from 'react-router-dom'
import { Link as RouterLink } from 'react-router-dom'

export type LinkButtonProps = ButtonProps & RouterLinkProps

const LinkButton = ({ to, ...props }: LinkButtonProps): JSX.Element => (
  <Button component={RouterLink} to={to} {...props}>
    {props.children}
  </Button>
)

export default LinkButton
